module.exports = __webpack_public_path__ + "static/media/our-benefits.fde5973b.png";